<script setup>
import notification from "@/utils/plugins/NotificationService";
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUiStore } from "@/app/stores/uiStore";
import FormProject from './FormProject.vue'
import ProjectsService from '@/api/services/projects.service'

const router = useRouter()
const route = useRoute()
const uiStore = useUiStore();

const getTodayLocalDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const project = ref({
  name: '',
  client: null,
  projectType: null,
  initialDate: getTodayLocalDate(),
  contractedTime: 0,
  projectEstimationDocuments: [],
  projectProposalDocuments: [],
  observations: '',
  tag: '',
  source: 'connectus',
  ownerDepartment: null,
  minConsumptionHours: 0,
  reviewPeriodMonths: null,
})

const createProject = async (item) => {
  uiStore.startLoading()

  try {
    const result = await ProjectsService.createProject(item)
    const createdProjectId = getProjectIdFromResponse(result)

    if (createdProjectId) {
      notification.addNotification({
        title: 'Nuevo proyecto',
        message: 'El proyecto se ha creado correctamente',
        type: 'success',
        duration: 6000,
      })
      router.push({ name: 'show-projects', params: { id: createdProjectId } })
      return
    }

    notification.addNotification({
      title: 'Nuevo proyecto',
      message: 'No se pudo crear el proyecto. Revisa los datos e inténtalo de nuevo.',
      type: 'warning',
      duration: 6000,
    })
  } catch (err) {
    notification.addNotification({
      title: 'Nuevo proyecto',
      message: 'Error al crear el proyecto ' + err,
      type: 'error',
      duration: 6000,
    })
  } finally {
    uiStore.stopLoading()
  }
}

const getProjectIdFromResponse = (response) => {
  if (response?.data?.id) return response.data.id
  if (!response?.data?.['@id']) return null

  const split = response.data['@id'].split('/')
  return split[split.length - 1]
}
</script>

<template>
  <form-project :project="project" :is-new="true" :locked-client-id="route.query.clientId" @change="createProject" />
</template>
